import { useTranslation } from 'react-i18next';
import Stat from './stat';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';

function ViewsStat({ data, previousData }) {
  const {t} = useTranslation()

  const isNoPeriodData = useSelector(
    (state) => state.meTicketData.isNoPeriodData
  );

  const percent = useMemo(() => {
    const previousValue = previousData?.summaryViewsByPeriod;
    if (!previousValue) return null;
    return parseInt(
      ((data.summaryViewsByPeriod - previousValue) / previousValue) * 100
    );
  }, [data.summaryViewsByPeriod, previousData]);
  return (
    <div className={classNames({ 'opacity-25': isNoPeriodData })}>
      <Stat
        icon={'eye'}
        mainLabel={t('ticketStatistic.viewsSummary')}
        smallLabel={t('ticketStatistic.viewsSummaryDescription')}
        value={data.summaryViews}
        percentage={percent}
        dataByPeriod={data.summaryViewsByPeriod}
      />
    </div>
  );
}

export default ViewsStat
